import React, { useState } from 'react';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';

const ChangePassword = () => {
  const toast = useRef(null);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.newPassword !== formData.confirmPassword) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'New passwords do not match',
        life: 3000
      });
      return;
    }

    if (formData.newPassword.length < 8) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Password must be at least 8 characters long',
        life: 3000
      });
      return;
    }

    setLoading(true);
    
    // Simulate password change
    setTimeout(() => {
      setLoading(false);
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Password changed successfully',
        life: 3000
      });
    }, 1500);
  };

  return (
    <div>
      <Toast ref={toast} />
      
      <div className="se-card">
        <div className="se-card-header">
          <h2>Change Password</h2>
        </div>
        <div className="se-card-content">
          <div className="mb-4">
            <Message
              severity="info"
              text="For your security, please use a strong password with at least 8 characters including uppercase, lowercase, numbers, and special characters."
              className="w-full"
            />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="grid">
              <div className="col-12 md:col-8 lg:col-6">
                <div className="se-form-group">
                  <label htmlFor="currentPassword" className="se-form-label">
                    Current Password <span className="se-form-required">*</span>
                  </label>
                  <Password
                    id="currentPassword"
                    value={formData.currentPassword}
                    onChange={(e) => handleInputChange('currentPassword', e.target.value)}
                    className="w-full"
                    inputClassName="w-full"
                    feedback={false}
                    toggleMask
                    required
                  />
                </div>

                <div className="se-form-group">
                  <label htmlFor="newPassword" className="se-form-label">
                    New Password <span className="se-form-required">*</span>
                  </label>
                  <Password
                    id="newPassword"
                    value={formData.newPassword}
                    onChange={(e) => handleInputChange('newPassword', e.target.value)}
                    className="w-full"
                    inputClassName="w-full"
                    toggleMask
                    promptLabel="Enter a password"
                    weakLabel="Weak"
                    mediumLabel="Medium"
                    strongLabel="Strong"
                    required
                  />
                </div>

                <div className="se-form-group">
                  <label htmlFor="confirmPassword" className="se-form-label">
                    Confirm New Password <span className="se-form-required">*</span>
                  </label>
                  <Password
                    id="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
                    className="w-full"
                    inputClassName="w-full"
                    feedback={false}
                    toggleMask
                    required
                  />
                </div>

                <div className="flex gap-2 mt-4">
                  <Button
                    type="submit"
                    label="Change Password"
                    loading={loading}
                    className="p-button-primary"
                  />
                  <Button
                    type="button"
                    label="Cancel"
                    className="p-button-secondary"
                    onClick={() => setFormData({
                      currentPassword: '',
                      newPassword: '',
                      confirmPassword: ''
                    })}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;